import { Box, TextField } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

function CommercialInfoContainer({ open }: { open: boolean }) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <>
      <SectionCollapsible open={open} label="Commercial Information">
        <Box data-testid="commercial-information-collapsible">
          <TextField
            id="solution-minimum-order"
            label="Minimum order"
            variant="standard"
            fullWidth
            sx={{ paddingBottom: 2 }}
            autoComplete="disabled"
            name="commercial-information.minimum-order"
            onBlur={context.handleBlur}
            onChange={(event) =>
              context.setFieldValue(
                "commercial-information.minimum-order",
                event.target.value,
              )
            }
            value={
              context.values["commercial-information"]?.["minimum-order"] ?? ""
            }
            error={
              context.touched["commercial-information"]?.["minimum-order"] &&
              Boolean(
                context.errors["commercial-information"]?.["minimum-order"],
              )
            }
            helperText={
              context.touched["commercial-information"]?.["minimum-order"] &&
              context.errors["commercial-information"]?.["minimum-order"]
            }
          />
        </Box>
      </SectionCollapsible>
    </>
  );
}

export default CommercialInfoContainer;
